import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';
import { PromoPage } from './promo';

@NgModule({
    declarations: [PromoPage],
    imports: [PagesModule, ComponentsModule]
})
export class PromoPageModule {}
